import { DefaultService } from '@/services/DefaultService';

export default class IntegracaoService extends DefaultService {

	constructor(http, router, env) {
		super(http, router, env);
	}

  findAll(page = 0, limit = 50, situacao, idcategoria = 0, ...params) {
    return this._http.get(encodeURI(`${this._env}/integracao/findall.json?situacao=${situacao}&page=${page}&idcategoria=${idcategoria}&limit=${limit}&param=${params}`), this._headers).then(res => {
      return res.body;
    }, err => {
      this.verifyError(err);
      throw new Error('Problems while jobs are loading');
    });
	}

    find(id){
        return this._http.get(`${this._env}/apipartner/${id}.json`, this._headers).then(res => {
            return res.body.content;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }
}